// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__MvUu8","container":"styles_container__3E7ZS","title":"styles_title__1Ow0N","wrapper":"styles_wrapper__11js9","answer":"styles_answer__3qduF"};